var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user.warehouseCompany.zohoIntegration
    ? _c("div", [
        _vm.user.zohoAuthenticated
          ? _c("span", [_vm._v("Zoho Authenticated")])
          : _c("a", { attrs: { href: _vm.user.zohoAuthUrl } }, [
              _vm._v("\n\t\t" + _vm._s(_vm.$t("authenticateWithZoho")) + "\n\t")
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }